import { useEffect, useState } from "react";
import { getSelf } from "../api/user";

export function useUser(projectId, token = window.localStorage.getItem("token")) {
  const [user, setUser] = useState();
  const [isGettingUser, setIsGettingUser] = useState(false);

  useEffect(() => {
    if (token) {
      getUserInfo();
    }
  }, [token, projectId]);

  const getUserInfo = async () => {
    setIsGettingUser(true);
    const response = await getSelf(projectId);
    if (response) {
      setUser(response.data);
    } else {
      setUser("Token Expired");
    }
    setIsGettingUser(false);
  };

  return { user, isGettingUser };
}
